var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('ListadoSiniestros',{attrs:{"poliza":_vm.$route.params.id,"siniestro":_vm.$route.params.siniestro}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }